import { withSearch } from '@elastic/react-search-ui';
import MultiCheckboxFilter from '../../../components/filter/MultiCheckboxFilter';

function TeachingActivitiesKeyStageFilter({
  addFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <MultiCheckboxFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="keyStage"
      filters={filters}
      formHint="Select all that apply."
      id="key-stage"
      label="Key stage"
      orderByCount={false}
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, facets, filters }) => ({
  addFilter,
  removeFilter,
  facets,
  filters,
}))(TeachingActivitiesKeyStageFilter);
